export default "__VITE_ASSET__CZEG5Oxc__"